var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("account-overview", {
                attrs: {
                  type: "year",
                  title: "Time Period"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("reporting-period", {
                attrs: {
                  period: "yearly"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("campaign-tracking", {
                attrs: {
                  items: _vm.yearlyStatistics.campaignTracking
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("click-breakdown", {
                attrs: {
                  items: _vm.yearlyStatistics.clickBreakdown
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }